var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoublequote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 65,
    viewBox: "0 0 91 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6 64.4C77.4 64 90.6 53.4 90.6 27V-9.53674e-06H58.2V32H70.6C71.6 43.4 64.8 50.4 51 51.8L53.6 64.4ZM2.8 64.4C26.6 64 39.8 53.4 39.8 27V-9.53674e-06H7.4V32H19.8C20.8 43.4 14 50.4 0.2 51.8L2.8 64.4Z",
    fill: "#C7DC6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublequote);
export default __webpack_public_path__ + "static/media/doublequote.1cf90bf61b658fe55ebd2f8e37e5dad9.svg";
export { ForwardRef as ReactComponent };